import { InjectionToken } from '@angular/core';
import { environment } from '../../environments/environment';

export let APP_CONFIG = new InjectionToken('app.config');

export const AppSettingsConfig = {
	supportEmail: 'support@v-locker.ch',
	supportPhone: '+80086000068',
	privacyPolicy: {
		en: 'https://live.v-locker.ch/en/privacy.html',
		de: 'https://live.v-locker.ch/de/datenschutz.html'
	},
	termsAndConditions: {
		en: 'https://live.v-locker.ch/en/terms.html',
		de: 'https://live.v-locker.ch/de/agb.html'
	},
	testStripeKey: 'pk_test_51HUC4LKLkCKTjXKJCewzdrbxbSEQxcgWcxOJ6p14hrRBuNkEprwqkmVz7MnpT9trp30WayacJSnRdLjrDLHc9OiE00BcRPvCEV',
	supportUrl: 'https://api.whatsapp.com/send?phone=+41796069593',
	distanceChecking: 2000000,
	snackBarDuration: 3000,
	pathToiConMoon: 'assets/icon/iconmoon/symbol-defs.svg',
	sentryDSN: 'https://38434a1b115f41d3a31e356cdc496c06@sentry.io/1315526',
	defaultTitle: 'V-Locker',
	defaultDescription: 'V-Locker',
	defaultImage: '',
	defaultLanguage: 'en',
	// passwordPattern: '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d@#$%^&*()_+.~]{8,}$',
	passwordPattern: '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,30}$',
	// passwordPattern: '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d@#$%^&*()_+.~,:;=?@$|\'<>.^*()%!-]{8,}$',

	defaultCookieAnnounce: {
		en: ``,
		ge: ``
	},
	emailPattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
	phonePattern: /((\+38)?\(?\d{3}\)?[\s\.-]?(\d{7}|\d{3}[\s\.-]\d{2}[\s\.-]\d{2}|\d{3}-\d{4}))/,
	languages: {
		en: { name: 'en', label: 'english' },
		ge: { name: 'de', label: 'german' }
	},

	langHtml: {
		en: 'en-En',
		ge: 'ge-GE',
	},

	loggerColors: [
		'gray',  // TRACE = 0
		'teal',  // DEBUG = 1
		'green', // INFO = 2
		'blue',  // LOG = 3
		'red',   // WARN = 4
		'red',   // ERROR = 5
		'red',   // FATAL = 6
	],

	myLoggerColors: {
		trace: 'gray',
		log: 'gray',
		info: 'green',
		error: 'red',
		debug: 'orange',
	},

	cspDirectives: {
		defaultSrc: [
			'\'self\'',
			'http://*.google-analytics.com',
			'https://static.hotjar.com',
			'http://www.googletagmanager.com',
			'https://*.google.com',
			'https://*.google-analytics.com',
			'https://*.googletagmanager.com',
			'https://*.gstatic.com',
			'https://*.googleapis.com',
			'https://authedmine.com',
			'https://az743702.vo.msecnd.net',
			'https://sentry.io',
			'ws://localhost:8100',
			(!document.location.origin.includes('localhost') ? document.location.origin: environment.api),
			'https://reqres.in'
		],
		styleSrc: [
			'\'self\'',
			'\'unsafe-inline\'',
			'https://*.googleapis.com',
			'https://tagmanager.google.com',
		],
		scriptSrc: [
			'\'self\'',
			'\'unsafe-inline\'',
			'http://*.googletagmanager.com',
			'https://*.googletagmanager.com',
			'https://*.google-analytics.com',
			'https://script.hotjar.com',
			'https://www.googleadservices.com',
			'https://static.hotjar.com',
			'https://tagmanager.google.com',
			'https://googleads.g.doubleclick.net'
		],
	},

	groupsRefreshInterval: 10000
};
